import { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { login, setAuth, api } from '../api';
import './LoginPage.css';

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [captchaId, setCaptchaId] = useState('');
  const captchaIdRef = useRef('');  // ref 确保回调中始终取到最新值
  const [captchaSvg, setCaptchaSvg] = useState('');
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const refreshCaptcha = useCallback(() => {
    api.get('/auth/captcha').then(res => {
      if (res.data.success) {
        setCaptchaId(res.data.captcha_id);
        captchaIdRef.current = res.data.captcha_id;
        setCaptchaSvg(res.data.captcha_svg);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => { refreshCaptcha(); }, [refreshCaptcha]);

  const handleSubmit = useCallback(async (values) => {
    const cid = captchaIdRef.current;
    if (!cid) { message.warning('验证码未加载，请刷新'); return; }
    if (!values.captcha) { message.warning('请输入验证码'); return; }
    setLoading(true);
    try {
      const res = await login(values.username, values.password, cid, values.captcha);
      if (res.data.success) {
        setAuth(res.data.token, res.data.user);
        message.success('登录成功');
        navigate('/', { replace: true });
      } else {
        message.error(res.data.message);
        const msg = res.data.message || '';
        if (msg.includes('验证码') && (msg.includes('过期') || msg.includes('无效'))) {
          refreshCaptcha();
        }
        form.setFieldValue('captcha', '');
      }
    } catch {
      message.error('登录失败，请重试');
      refreshCaptcha();
    }
    setLoading(false);
  }, []);

  return (
    <div className="login-container">
      <Card className="login-card" bordered={false}>
        <div className="login-header">
          <div style={{ fontSize: 36, color: '#1677ff', marginBottom: 8 }}>📦</div>
          <h1 style={{ color: '#1677ff' }}>到货签收平台</h1>
          <p>请输入您的账号和密码登录</p>
        </div>
        <Form form={form} onFinish={handleSubmit} size="large" autoComplete="off">
          <Form.Item name="username" rules={[{ required: true, message: '请输入账号' }]}>
            <Input prefix={<UserOutlined />} placeholder="客户编码 / 客户名称" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>

          {/* 验证码 */}
          <div style={{ marginBottom: 24, display: 'flex', gap: 10, alignItems: 'center' }}>
            <Form.Item name="captcha" noStyle rules={[{ required: true, message: '请输入验证码' }]}>
              <Input
                placeholder="验证码"
                maxLength={4}
                style={{ flex: 1, fontSize: 16, textAlign: 'center', letterSpacing: 4, textTransform: 'uppercase' }}
              />
            </Form.Item>
            <div
              onClick={refreshCaptcha}
              style={{
                width: 130, height: 48, flexShrink: 0,
                cursor: 'pointer', borderRadius: 8, overflow: 'hidden',
              }}
              title="点击刷新验证码"
              dangerouslySetInnerHTML={{ __html: captchaSvg || '<svg xmlns="http://www.w3.org/2000/svg" width="120" height="48"><rect width="120" height="48" fill="#f5f5f5" rx="8"/><text x="60" y="32" font-size="14" fill="#999" text-anchor="middle" font-family="Arial">加载中</text></svg>' }}
            />
          </div>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              登 录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
